import React, { createContext, useCallback, useContext, useState } from "react";

/**
 * Toast ringan khusus area admin. Panggil via useAdminToast():
 *   const toast = useAdminToast(); toast.success("..."); toast.error("...");
 */
const ToastContext = createContext(null);
let idCounter = 0;

export function AdminToastProvider({ children }) {
  const [items, setItems] = useState([]);

  const remove = useCallback((id) => setItems((prev) => prev.filter((t) => t.id !== id)), []);
  const push = useCallback(
    (type, message) => {
      const id = ++idCounter;
      setItems((prev) => [...prev, { id, type, message }]);
      setTimeout(() => remove(id), 4000);
    },
    [remove]
  );

  const toast = {
    success: (m) => push("success", m),
    error: (m) => push("error", m),
    info: (m) => push("info", m),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className="fixed top-4 right-4 z-[60] flex flex-col gap-2 w-80 max-w-[90vw]">
        {items.map((t) => (
          <div
            key={t.id}
            className={
              "rounded-lg px-4 py-3 text-sm shadow-lg border flex items-start gap-2 " +
              (t.type === "success"
                ? "bg-emerald-50 border-emerald-200 text-emerald-800"
                : t.type === "error"
                ? "bg-rose-50 border-rose-200 text-rose-800"
                : "bg-slate-50 border-slate-200 text-slate-700")
            }
          >
            <span className="font-medium">{t.type === "success" ? "✓" : t.type === "error" ? "✕" : "ℹ"}</span>
            <span className="flex-1">{t.message}</span>
            <button onClick={() => remove(t.id)} className="text-slate-400 hover:text-slate-600">×</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useAdminToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useAdminToast harus di dalam AdminToastProvider");
  return ctx;
}
